import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogWorkTypesUpdatedDateGql } from '../catalogTypesWorkQuery';

interface IUseCatalogWorkTypesUpdatedDate {
    catalogId: number;
}

export const useCatalogWorkTypesUpdatedDate = ({ catalogId }: IUseCatalogWorkTypesUpdatedDate) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            catalogId,
        }),
        [catalogId],
    );

    const [resetUpdatedDateData] = useResetStoreData({ requestId: 'workTypesUpdatedDate' });

    const [
        workTypesUpdatedDateData,
        workTypesUpdatedDateStatus,
        workTypesUpdatedDateError,
        workTypesUpdatedDateRequest,
    ] = useRequest({
        requestId: 'workTypesUpdatedDate',
        query: catalogWorkTypesUpdatedDateGql,
        withEffect: Boolean(catalogId),
        variables,
    });

    const handlerWorkTypesUpdatedDate = useCallback(() => {
        dispatch(workTypesUpdatedDateRequest({ catalogId }));
    }, [catalogId, dispatch, workTypesUpdatedDateRequest]);

    const workTypesDateInProgress = workTypesUpdatedDateStatus === RequestStatus.FETCHING;

    return {
        updatedDate: workTypesUpdatedDateData?.catalogWorkTypesUpdatedDate?.data?.updatedAt,
        workTypesDateInProgress,
        workTypesUpdatedDateError,
        handlerWorkTypesUpdatedDate,
        resetUpdatedDateData,
    };
};
